import React, { useState, useEffect } from 'react'
import Graphviz, { Container, GraphContainer } from './Styled'
import BuilderLayout from '../../layouts/builderLayout/BuilderLayout'
import { useDispatch, useSelector } from 'react-redux'
import { createLoadingSelector } from '../../../business/selectors/loadingSelectors'
import { RootState } from '../../../model/rootReducer'
import { graphToDot, pathToDot } from '../../../helpers/monitoringGraphHelper'
import Loader from '../../system/loader/Loader'
import {
  getMonitoringPathAction,
  updateMonitoringGraphAction,
  updateMonitoringPathAction,
} from '../../../business/actions/monitoringGraphActions'
import { saveSvgAsPng } from 'save-svg-as-png'
import { Tabs } from 'antd'
import MonitoringGraphPanel from './monitoringPanel/MonitoringGraphPanel'
import { Sider } from './monitoringPanel/Styled'
import MonitoringPathPanel from './monitoringPanel/MonitoringPathPanel'
import notification from '../../../helpers/notification'
const { TabPane } = Tabs

const graphTab = '1'
const pathTab = '2'
const initialGraph = 'digraph{}'

const MonitoringGraph: React.FunctionComponent = (props: any) => {
  const dispatch = useDispatch()
  const [options, setOptions] = useState({
    zoom: true,
    width: '100%',
    height: '100%',
  })
  const [percentage, setPercentage] = useState([1, 100])
  const [activeTab, setActiveTab] = useState(graphTab)
  const [graph, setGraph] = useState(initialGraph)
  const [path, setPath] = useState(initialGraph)
  const loadingSelector = createLoadingSelector([
    'GET_MONITORING_GRAPH',
    'GET_MONITORING_PATH',
    'GET_EVENTS',
  ])
  const isFetching = useSelector((state: RootState) => loadingSelector(state))
  const selectedBotId = useSelector((state: RootState) => state.bot.selectedBot)
  const graphData = useSelector(
    (state: RootState) => state.monitoringGraph.graph
  )
  const pathData = useSelector((state: RootState) => state.monitoringGraph.path)

  useEffect(() => {
    if (props.location.state.conversationId) {
      setActiveTab(pathTab)
      dispatch(
        getMonitoringPathAction.request({
          conversationId: props.location.state.conversationId,
          events: '',
          actions: '',
        })
      )
    }
  }, [props.location.state.conversationId])

  useEffect(() => {
    if (selectedBotId) {
      setGraph(initialGraph)
      setPath(initialGraph)
      dispatch(updateMonitoringGraphAction.request({ availableActions: [] }))
      dispatch(updateMonitoringPathAction.request({ availableActions: [] }))
    }
  }, [selectedBotId])

  useEffect(() => {
    if (pathData.exist == false) {
      notification.error("Le graph demandé n'existe pas")
      dispatch(updateMonitoringPathAction.request({ exist: true }))
    }
    if (pathData.links.length > 0) {
      setPath(pathToDot(pathData.links))
      dispatch(updateMonitoringPathAction.request({ links: [] }))
    }
  }, [pathData.links])

  useEffect(() => {
    if (graphData.exist == false) {
      notification.error("Le graph demandé n'existe pas")
      dispatch(updateMonitoringGraphAction.request({ exist: true }))
    }
    if (graphData.links.length > 0) {
      setGraph(graphToDot(graphData, percentage[0], percentage[1]))
      dispatch(updateMonitoringGraphAction.request({ links: [] }))
    }
  }, [graphData.links])

  const exportImage = async () => {
    await setOptions({
      zoom: true,
      width: '100%',
      height: '100%',
    })
    const svg = document
      .getElementById('monitoringGraph')
      ?.getElementsByTagName('svg')[0]
    saveSvgAsPng(svg, 'monitoringGraph.png')
  }

  const changeTab = (activeKey: any) => {
    if (activeKey === pathTab) {
      setActiveTab(pathTab)
    }
    if (activeKey === graphTab) {
      setActiveTab(graphTab)
    }
  }

  const Graph = () => {
    if (activeTab == graphTab) {
      return (
        <GraphContainer id="monitoringGraph">
          <Graphviz dot={graph} options={options} />
        </GraphContainer>
      )
    } else {
      return (
        <GraphContainer id="monitoringGraph">
          <Graphviz dot={path} options={options} />
        </GraphContainer>
      )
    }
  }

  return (
    <Loader isLoading={isFetching}>
      <BuilderLayout
        onBackDestination="/"
        title={'Monitoring graph'}
        subTitle={
          "Générez le graph d'un ensemble de conversations téléphoniques"
        }
      >
        <Container>
          <Sider>
            <Tabs
              activeKey={activeTab}
              onChange={(activeKey) => changeTab(activeKey)}
            >
              <TabPane tab="Graph" key={graphTab}>
                <MonitoringGraphPanel
                  exportImage={exportImage}
                  setPercentage={(percentageRange: number[]) =>
                    setPercentage(percentageRange)
                  }
                />
              </TabPane>
              <TabPane tab="Chemin" key={pathTab}>
                <MonitoringPathPanel exportImage={exportImage} />
              </TabPane>
            </Tabs>
          </Sider>
          <Graph />
        </Container>
      </BuilderLayout>
    </Loader>
  )
}

export default MonitoringGraph
